import { render, staticRenderFns } from "./ResultsTableSkeletonLoader.vue?vue&type=template&id=4c2db43e"
import script from "./ResultsTableSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./ResultsTableSkeletonLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports